export default "__VITE_ASSET__3b479c89__"